import { render, staticRenderFns } from "./QueenCreate.vue?vue&type=template&id=095580ed&scoped=true&"
import script from "./QueenCreate.vue?vue&type=script&lang=js&"
export * from "./QueenCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095580ed",
  null
  
)

export default component.exports